import { axiosPatch } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import type { z } from 'zod';
import { UpdateProfileSchema } from '../_models/profile';

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: async (values: z.infer<typeof UpdateProfileSchema>) => {
      const payload = UpdateProfileSchema.parse(values);
      return await axiosPatch('/api/me/profile/', payload);
    },
  });
};
